module.exports = __webpack_public_path__ + "img/rose-bouqet.92425b06.svg";